import { request } from 'umi';

export async function getTeamsApi(params?: API.TeamGetParamtersType) {
  return request<API.PageDataType<API.Team>>('/team/all', {
    method: 'get',
    params,
  });
}
